<div class="my-3 my-md-5">
    <div class="container">
        <div class="page-header">
            <span class="bold">Payment Summary</span>
        </div>
        <div class="row ">
            <div class="col-sm-3">
                <mat-form-field appearance="fill">
                    <mat-label>Enter a date range</mat-label>
                    <mat-date-range-input [rangePicker]="picker">
                        <input matStartDate #dateRangeStart placeholder="Start date">
                        <input matEndDate #dateRangeEnd placeholder="End date" (dateChange)="dateRangeChangecity(dateRangeStart, dateRangeEnd)">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>
                <mat-icon (click)="clearDate(1)">clear</mat-icon>
            </div>
            <div class="col-sm-2 mt-2">
                <mat-select  placeholder="Select Treatment" (selectionChange)="getCityWisePerformanceFieldSales()" [(ngModel)]="circle_treatment">
                    <mat-option >Select Treatment</mat-option>
                    <mat-option value="{{ltreatment.id}}" *ngFor="let ltreatment of treatList">{{ltreatment.name}}</mat-option>
                </mat-select>
            </div>
            <!-- <div class="col-sm-2 mt-2">
                <button type="button" class="btn btn-success ml-2" [disabled]="circle_wise_sales_payment_loading" (click)="exportCircldeWisePerformanceField()"><i class="fa fa-file-excel"></i> Export List</button>
            </div> -->
        </div>
        <div class="row row-cards mt-2">
            <div class="card">
                <div class="table-responsive">
                    <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
                        <thead>
                            <tr class="text-center">
                                <th colspan="12"><b>Circle Wise Performance-field Sales</b></th>
                            </tr>
                            <tr class="text-center">
                                <th>Circle</th>
                                <th>Total Leads</th>
                                <th>Total SB</th>
                                <th>MTD SD</th>
                                <th>MTD Converted</th>
                                <th>Inside Sale</th>
                                <th>Revenue Locked</th>
                                <th>MTD Revenue</th>
                                <th>Cash Count</th>
                                <th>Cash Received</th>
                                <th>Balance Payment</th>
                                <th>Balance %</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="text-center" *ngFor="let tdata of performanceFieldSales" >
                                <td>{{tdata.name}}</td>
                                <td>{{tdata.lead_count | number : '1.0-0'}}</td>
                                <td>{{tdata.total_sb | number : '1.0-0'}}</td>
                                <td>{{tdata.mtd_sd | number : '1.0-0'}}</td>
                                <td>{{tdata.mtd_converted | number : '1.0-0'}}</td>
                                <td>{{tdata.inside_sale | number : '1.0-0'}}</td>
                                <td>{{tdata.revenue_locked | number : '1.0-0'}}</td>
                                <td>{{tdata.mtd_revenue | number : '1.0-0'}}</td>
                                <td>{{tdata.cash_count | number : '1.0-0'}}</td>
                                <td>{{tdata.cash_received | number : '1.0-0'}}</td>
                                <td>{{tdata.balance_payment | number : '1.0-0'}}</td>
                                <td>{{tdata.balance | number : '1.2-2'}}</td>
                            </tr> 
                            <tr *ngIf="circle_wise_sales_payment_loading">
                                <td colspan="12" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                            </tr>
                            <tr class="text-center">
                                <td><b>Overall</b></td>
                                <td><b>{{total_lead_count | number : '1.0-0'}}</b></td>
                                <td><b>{{total_total_sb | number : '1.0-0'}}</b></td>
                                <td><b>{{total_mtd_sd | number : '1.0-0'}}</b></td>
                                <td><b>{{total_mtd_converted | number : '1.0-0'}}</b></td>
                                <td><b>{{total_inside_sale | number : '1.0-0'}}</b></td>
                                <td><b>{{total_revenue_locked | number : '1.0-0'}}</b></td>
                                <td><b>{{total_mtd_revenue | number : '1.0-0'}}</b></td>
                                <td><b>{{total_cash_count | number : '1.0-0'}}</b></td>
                                <td><b>{{total_cash_received | number : '1.0-0'}}</b></td>
                                <td><b>{{total_balance_payment | number : '1.0-0'}}</b></td>
                                <td><b>{{total_balance | number : '1.2-2'}}</b></td>
                            </tr> 
                            
                        </tbody>
                    </table>
                </div>
            </div>
        </div> 

        <hr>

        <div class="row ">
            <div class="col-sm-3">
            <mat-form-field appearance="fill">
                <mat-label>Enter a date range</mat-label>
                <mat-date-range-input [rangePicker]="sp_picker">
                    <input matStartDate #dateRangeStart2 placeholder="Start date">
                    <input matEndDate #dateRangeEnd2 placeholder="End date" (dateChange)="dateRangeChangeSP(dateRangeStart2, dateRangeEnd2)">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="sp_picker"></mat-datepicker-toggle>
                <mat-date-range-picker #sp_picker></mat-date-range-picker>
            </mat-form-field>
            <mat-icon (click)="clearDate(2)">clear</mat-icon>
            </div>
            <div class="col-sm-2 mt-2">
                <mat-select  placeholder="Select Treatment" (selectionChange)="getScanProWisePerformanceFieldSales()" [(ngModel)]="sp_treatment">
                    <mat-option >Select Treatment</mat-option>
                    <mat-option value="{{ltreatment.id}}" *ngFor="let ltreatment of treatList">{{ltreatment.name}}</mat-option>
                </mat-select>
            </div>
            <!-- <div class="col-sm-2 mt-2">
                <button type="button" class="btn btn-success ml-2" [disabled]="spro_wise_sales_payment_loading" (click)="exportProWisePerformanceField()"><i class="fa fa-file-excel"></i> Export List</button>
            </div> -->
        </div>
        <div class="row row-cards mt-2">
            <div class="card">
                <div class="table-responsive">
                    <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
                        <thead>
                            <tr class="text-center">
                                <th colspan="10"><b>Pro Wise Performance-field Sales</b></th>
                            </tr>
                            <tr class="text-center">
                                <th>Scan Pro User</th>
                                <th>MTD SD</th>
                                <th>MTD Converted</th>
                                <th>Inside Sale</th>
                                <th>Revenue Locked</th>
                                <th>MTD Revenue</th>
                                <th>Cash Count</th>
                                <th>Cash Received</th>
                                <th>Balance Payment</th>
                                <th>Balance %</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="text-center" *ngFor="let tdata of spperformanceFieldSales" >
                                <td>{{tdata.name}}</td>
                                <td>{{tdata.mtd_sd | number : '1.0-0'}}</td>
                                <td>{{tdata.mtd_converted | number : '1.0-0'}}</td>
                                <td>{{tdata.inside_sale | number : '1.0-0'}}</td>
                                <td>{{tdata.revenue_locked | number : '1.0-0'}}</td>
                                <td>{{tdata.mtd_revenue | number : '1.0-0'}}</td>
                                <td>{{tdata.cash_count | number : '1.0-0'}}</td>
                                <td>{{tdata.cash_received | number : '1.0-0'}}</td>
                                <td>{{tdata.balance_payment | number : '1.0-0'}}</td>
                                <td>{{tdata.balance | number : '1.2-2'}}</td>
                            </tr> 
                            <tr *ngIf="spro_wise_sales_payment_loading">
                                <td colspan="10" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                            </tr>
                            <tr class="text-center">
                                <td><b>Overall</b></td>
                                <td><b>{{total_sp_mtd_sd | number : '1.0-0'}}</b></td>
                                <td><b>{{total_sp_mtd_converted | number : '1.0-0'}}</b></td>
                                <td><b>{{total_sp_inside_sale | number : '1.0-0'}}</b></td>
                                <td><b>{{total_sp_revenue_locked | number : '1.0-0'}}</b></td>
                                <td><b>{{total_sp_mtd_revenue | number : '1.0-0'}}</b></td>
                                <td><b>{{total_sp_cash_count | number : '1.0-0'}}</b></td>
                                <td><b>{{total_sp_cash_received | number : '1.0-0'}}</b></td>
                                <td><b>{{total_sp_balance_payment | number : '1.0-0'}}</b></td>
                                <td><b>{{total_sp_balance | number : '1.2-2'}}</b></td>
                            </tr> 
                            
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <hr>
        <div class="row ">
            <div class="col-sm-3">
            <mat-form-field appearance="fill">
                <mat-label>Enter a date range</mat-label>
                <mat-date-range-input [rangePicker]="bd_picker">
                    <input matStartDate #dateRangeStart3 placeholder="Start date">
                    <input matEndDate #dateRangeEnd3 placeholder="End date" (dateChange)="dateRangeChangeBD(dateRangeStart3, dateRangeEnd3)">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="bd_picker"></mat-datepicker-toggle>
                <mat-date-range-picker #bd_picker></mat-date-range-picker>
            </mat-form-field>
            <mat-icon (click)="clearDate(3)">clear</mat-icon>
            </div>
            <div class="col-sm-2 mt-2">
                <mat-select  placeholder="Select Treatment" (selectionChange)="getBDWisePerformanceFieldSales()" [(ngModel)]="bd_treatment">
                    <mat-option >Select Treatment</mat-option>
                    <mat-option value="{{ltreatment.id}}" *ngFor="let ltreatment of treatList">{{ltreatment.name}}</mat-option>
                </mat-select>
            </div>
            <!-- <div class="col-sm-2 mt-2">
                <button type="button" class="btn btn-success ml-2" [disabled]="bd_wise_sales_payment_loading" (click)="exportBDWisePerformanceField()"><i class="fa fa-file-excel"></i> Export List</button>
            </div> -->
        </div>
        <div class="row row-cards mt-2">
            <div class="card">
                <div class="table-responsive">
                    <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
                        <thead>
                            <tr class="text-center">
                                <th colspan="13"><b>BD Wise Performance-field Sales</b></th>
                            </tr>
                            <tr class="text-center">
                                <th>BD Name</th>
                                <th>Lead Assigned</th>
                                <th>Total SB</th>
                                <th>MTD SD</th>
                                <th>MTD Converted</th>
                                <th>Inside Sale</th>
                                <th>Revenue Locked</th>
                                <th>MTD Revenue</th>
                                <th>Cash Count</th>
                                <th>Cash Received</th>
                                <th>Balance Payment</th>
                                <th>Balance %</th>
                                <th>SB %</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="text-center" *ngFor="let tdata of bdperformanceFieldSales" >
                                <td>{{tdata.name}}</td>
                                <td>{{tdata.assigned_lead | number : '1.0-0'}}</td>
                                <td>{{tdata.total_sb | number : '1.0-0'}}</td>
                                <td>{{tdata.mtd_sd | number : '1.0-0'}}</td>
                                <td>{{tdata.mtd_converted | number : '1.0-0'}}</td>
                                <td>{{tdata.inside_sale | number : '1.0-0'}}</td>
                                <td>{{tdata.revenue_locked | number : '1.0-0'}}</td>
                                <td>{{tdata.mtd_revenue | number : '1.0-0'}}</td>
                                <td>{{tdata.cash_count | number : '1.0-0'}}</td>
                                <td>{{tdata.cash_received | number : '1.0-0'}}</td>
                                <td>{{tdata.balance_payment | number : '1.0-0'}}</td>
                                <td>{{tdata.balance | number : '1.2-2'}}</td>
                                <td>{{tdata.sb_per | number : '1.2-2'}}</td>
                            </tr> 
                            <tr *ngIf="bd_wise_sales_payment_loading">
                                <td colspan="13" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                            </tr>
                            <tr class="text-center">
                                <td><b>Overall</b></td>
                                <td><b>{{total_bd_assigned_lead | number : '1.0-0'}}</b></td>
                                <td><b>{{total_bd_sb | number : '1.0-0'}}</b></td>
                                <td><b>{{total_bd_mtd_sd | number : '1.0-0'}}</b></td>
                                <td><b>{{total_bd_mtd_converted | number : '1.0-0'}}</b></td>
                                <td><b>{{total_bd_inside_sale | number : '1.0-0'}}</b></td>
                                <td><b>{{total_bd_revenue_locked | number : '1.0-0'}}</b></td>
                                <td><b>{{total_bd_mtd_revenue | number : '1.0-0'}}</b></td>
                                <td><b>{{total_bd_cash_count | number : '1.0-0'}}</b></td>
                                <td><b>{{total_bd_cash_received | number : '1.0-0'}}</b></td>
                                <td><b>{{total_bd_balance_payment | number : '1.0-0'}}</b></td>
                                <td><b>{{total_bd_balance | number : '1.2-2'}}</b></td>
                                <td><b>{{total_sb_per | number : '1.2-2'}}</b></td>
                            </tr> 
                            
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
